import axios from 'axios'
import { OAUTH_BASE_URL, APPS_DASHBOARDS_URL } from './config'

export async function setLoginParams (params) {
  const { data } = await axios.get(`${OAUTH_BASE_URL}/authorize`, { params, withCredentials: true })
  const { translations } = data.customization
  this.authType = 'farmacloud'
  this.maintenance = data.maintenance
  this.signup = translations.es_es?.sign_up_link_url || translations.ca_es?.sign_up_link_url
  this.loginMethods = ['email']
  data.customization.logo_color = translations.es_es?.logo_url || translations.ca_es?.logo_url
  return { ...data, translations }
}

export async function loadSession (_, context) {
  const data = await this.setLoginParams()
  this.loginMethods = ['email']
  if (context === 'confirm') {
    const { data: perms } = await axios.get(`${OAUTH_BASE_URL}/customization-perms`, { withCredentials: true })
    data.info = {
      appName: perms.appName,
      appLogo: perms.appLogo,
      appScopes: perms.appScopes
    }
  }
  return data
}

export async function getToken () {
  const { data } = await axios.get(`${OAUTH_BASE_URL}/auth/user/v1/token`, { withCredentials: true })
  return data.token
}

export async function checkToken () {
  const token = await getToken()
  if (token) {
    this.redirecting = true
    window.location = APPS_DASHBOARDS_URL
    throw new Error('redirecting')
  }
}

export async function sendAutologin (email) {
  /** TODO: Farmacloud autologin */
}

export async function sendCustomerCode (dni) {
  /** TODO: Farmacloud customer code */
}
